export const APP_LANGUAGE_SYSTEM = "system";
export const APP_LANGUAGE_ENGLISH = "en";
export const APP_LANGUAGE_HEBREW = "he";
export const APP_THEME_SYSTEM = "system";
export const APP_THEME_LIGHT = "light";
export const APP_THEME_DARK = "dark";
export const APP_THEME_INVERSE = "inverse";

const appLanguages = new Set([
  APP_LANGUAGE_SYSTEM,
  APP_LANGUAGE_ENGLISH,
  APP_LANGUAGE_HEBREW
]);

const appThemes = new Set([
  APP_THEME_SYSTEM,
  APP_THEME_LIGHT,
  APP_THEME_DARK,
  APP_THEME_INVERSE
]);

export const defaultAppSettings = {
  language: APP_LANGUAGE_SYSTEM,
  theme: APP_THEME_SYSTEM
};

function normalizeAppLanguage(value) {
  return appLanguages.has(value) ? value : defaultAppSettings.language;
}

function normalizeAppTheme(value) {
  return appThemes.has(value) ? value : defaultAppSettings.theme;
}

export function normalizeAppSettings(settings = {}) {
  return {
    language: normalizeAppLanguage(settings?.language),
    theme: normalizeAppTheme(settings?.theme)
  };
}

export function mergeAppSettings(currentSettings = {}, nextSettings = {}) {
  return normalizeAppSettings({
    ...normalizeAppSettings(currentSettings),
    ...nextSettings
  });
}
